import { type BooleanFilter } from '../model'

export class BooleanMatch {
  constructor(private value?: BooleanFilter) {}

  matches(value?: boolean): boolean {
    if (this.value === undefined) return true
    if (this.value === 'undefined') return value === undefined
    if (this.value === 'defined') return value !== undefined
    if (this.value === 'true') return value === true
    if (this.value === 'false') return value === false
    throw new Error('Invalid boolean filter')
  }
}

export function isTrue(value: string | boolean | undefined | null | number): boolean {
  if (value === undefined) return false
  if (value === null) return false
  if (typeof value === 'boolean') return value

  const val = value.toString().toLowerCase()
  if (val === 'true') return true
  if (val === 't') return true
  if (val === 'yes') return true
  if (val === 'y') return true
  if (val === '1') return true
  return false
}

export function isFalse(value: string | boolean | undefined): boolean {
  if (value === undefined) return false
  if (typeof value === 'boolean') return !value
  const val = value.toLowerCase()
  if (val === 'false') return true
  if (val === 'f') return true
  if (val === 'no') return true
  if (val === 'n') return true
  if (val === '0') return true
  return false
}
